import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type Props = {
  summary: string;
  isLoading: boolean;
};

export const SummaryBody = ({ summary, isLoading }: Props) => {
  useEffect(() => {
    console.log(summary);
  }, []);

  return (
    <div className="summary_modal_body">
      {isLoading ? (
        <div>Nalagam povzetek...</div>
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{summary}</ReactMarkdown>
      )}
    </div>
  );
};
